import qs from "query-string";

class Router {
  static routes = {};

  static url_for(name) {
    return Router.routes[name];
  }

  static router(pathMatch) {
    const parts = pathMatch.match(/(:([\w\d]+)|\*([\w\d]+))/g) || [];

    const pathRouter = function () {
      let path = pathMatch.toString();
      let formatSuffix = "";

      if (arguments.length) {
        if (typeof arguments[0] === "object") {
          const args = arguments[0];

          if (args && args.format) {
            formatSuffix = `.${args.format}`;
          }

          parts.map((part) => {
            const sliced = part.slice(1);

            if (args[sliced] !== undefined) {
              path = path.replace(part, args[sliced]);
            }
          });
        } else {
          const args = Array.prototype.slice.call(arguments);

          parts.map((part, index) => {
            if (args[index] !== undefined) {
              path = path.replace(part, args[index]);
            }
          });
        }
      }
      const queryString =
        typeof arguments[arguments.length - 1] === "object" &&
        arguments.length > 1
          ? `?${qs.stringify(arguments[arguments.length - 1])}`
          : "";
      return `${path}${formatSuffix}${queryString}`;
    };

    return pathRouter;
  }

  static add(routes) {
    for (name in routes) {
      Router.routes[name] = routes[name];
      this[`${name}_path`] = Router.router(routes[name]);
    }
    return routes;
  }
}

export default Router;
